// kn-br-customer-emulation.component.ts
import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AsmComponentService, CustomerEmulationComponent } from '@spartacus/asm/components';
import { TranslatePipe } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { KnBrCsAgentAuthService } from '../../../../app/services/kn-br-csagent-auth.service';

@Component({
    selector: 'cx-customer-emulation',
    templateUrl: './kn-br-customer-emulation.component.html',
    styleUrls: ['./kn-br-customer-emulation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrCustomerEmulationComponent extends CustomerEmulationComponent implements OnInit, OnDestroy {
  constructor(protected asmComponentService: AsmComponentService, protected userService: UserAccountFacade, protected knBrCsAgentAuthService: KnBrCsAgentAuthService) {
    super(asmComponentService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  override logoutCustomer(): void {
    this.knBrCsAgentAuthService.endCustomerEmulationSession();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
